export const commonUrl = "/actgateway/marketcenter.java.active.template.website"; //接口站

/*接口地址start  请为接口写上相应的注释*/
export const appApi = {

    pagesDeatil: commonUrl + "/all/api/activity/details",  //获取页面详情  

    getNodeConfig: commonUrl + "/all/api/activity/getNodeConfig",  //获取页面详情  

};
